import React, { createContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { storeId, userRefreshToken, userToken } from "../../global_vars";
import { useNavigate } from "react-router-dom";
import GenericCard from "../../components/cards/GenericCard";
import EuSalesDistribution from "../../components/eu-sales-distribution";
import TopTable from "../../components/TopTable";
import Revenue from "../../components/revenue";

import card1 from "../../assets/images/dragndrop/card1.png";
import card2 from "../../assets/images/dragndrop/card2.png";
import card3 from "../../assets/images/dragndrop/card3.png";
import card4 from "../../assets/images/dragndrop/card4.png";
import revenue from "../../assets/images/dragndrop/revenu.png";
import topCountries from "../../assets/images/dragndrop/top-countries.png";
import topProducts from "../../assets/images/dragndrop/top-products.png";
import euDist from "../../assets/images/dragndrop/eu-distribution.png";
import ValidTaxRateCard from "../../components/cards/ValidTaxRateCard";
import { URLS, URLS_USERS } from "../../configuration/urls";
import { EcAuthContext } from "@eclear-ag/ec-common-ui";
import APIContext from "../api/api";

const UserContext = createContext();
const notis = [
  {
    date: "2022-02-04T19:54:41.684Z",
    id: 4,
    seen: false,
    title: "News",
    type: "info",
    msg: "Change in the Intrastat reporting as from 1 January 2022! Would you like to know more?"
  },
  {
    date: "2022-02-04T19:54:41.684Z",
    id: 2,
    seen: false,
    title: "Attention",
    type: "warning",
    msg: 'We recognised that you had shipments from other EU countries! Would you like to know more about local <span style="color: #FF9800">VAT filings</span> and <span style="color: #FF9800">OSS</span>?'
  },
  {
    date: "2022-02-04T19:54:41.684Z",
    id: 0,
    seen: false,
    title: "Attention",
    type: "error",
    msg: 'You seem to have <span style="color: #E01600">incorrect VAT rates</span> for certain countries in your bookings. Would you like to know more?'
  }
];

const initUserData = {
  ClientIdentifier: "",
  company: "",
  companyId: "",
  storeId: "",
  userInfo: {}
};

const initWidgetsList = [
  {
    name: "Revenu Actual Month Card",
    component: (
      <GenericCard
        key="w-0"
        titleId="revenueActualMonth"
        dataPath="month.total_revenue"
        showCurrency={true}
        tooltipAbsoluteId="revenueActualMonth.absoluteNumber"
        tooltipPercentId="revenueActualMonth.percentFigure"
        data-testid="revenue_actual_month"
      />
    ),
    id: 0,
    size: "widget-col-3",
    image: card1
  },
  {
    name: "Total Revenue this Year Card",
    component: (
      <GenericCard
        key="w-1"
        titleId="totalRevenueThisYear"
        dataPath="year.total_revenue"
        showCurrency={true}
        tooltipAbsoluteId="totalRevenueThisYear.absoluteNumber"
        tooltipPercentId="totalRevenueThisYear.percentFigure"
        data-testid="total_revenue_year"
      />
    ),
    id: 1,
    size: "widget-col-3",
    image: card2
  },
  {
    name: "Invoiced Orders this Year Card",
    component: (
      <GenericCard
        key="w-2"
        titleId="invoicedOrdersThisYear"
        dataPath="year.invoice_count"
        showCurrency={false}
        tooltipAbsoluteId="invoicedOrdersThisYear.absoluteNumber"
        tooltipPercentId="invoicedOrdersThisYear.percentFigure"
        data-testid="invoiced_orders_year"
      />
    ),
    id: 2,
    size: "widget-col-3",
    image: card3
  },
  {
    name: "Average Order Value Card",
    component: (
      <GenericCard
        key="w-3"
        titleId="averageInvoicedOrderValue"
        dataPath="year.average_revenue"
        showCurrency={true}
        tooltipAbsoluteId="averageInvoicedOrderValue.absoluteNumber"
        tooltipPercentId="averageInvoicedOrderValue.percentFigure"
        data-testid="average_order_value"
      />
    ),
    id: 3,
    size: "widget-col-3",
    image: card4
  },
  {
    name: "Revenue",
    component: <Revenue key="w-4" />,
    id: 4,
    size: "widget-col-12",
    image: revenue
  },
  {
    name: "Top Countries",
    component: (
      <TopTable
        key="w-5"
        dataUrl={URLS.TOTAL_REVENUE_TOP_COUNTRY}
        titleId="topCountries"
        tooltipTextId="topCountries.popup.text"
        csvLink="export/dashboard/tables/top-n-countries"
        fileName="topCountries"
        className="top-countries"
        type="countries"
        testIdPrefix="top_countries_table"
      />
    ),
    id: 5,
    size: "widget-col-6",
    image: topCountries
  },
  {
    name: "Top Products",
    component: (
      <TopTable
        key="w-6"
        dataUrl={URLS.TOTAL_REVENUE_TOP_PRODUCT}
        titleId="topProducts"
        tooltipTextId="topProducts.popup.text"
        csvLink="export/dashboard/tables/top-n-products"
        fileName="topProducts"
        className="top-products"
        type="products"
        testIdPrefix="top_products_table"
      />
    ),
    id: 6,
    size: "widget-col-6",
    image: topProducts
  },
  {
    name: "EU Sales Distribution",
    component: <EuSalesDistribution key="w-7" />,
    id: 7,
    size: "widget-col-12",
    image: euDist
  },

  {
    name: "Invoices with valid tax rates",
    component: (
      <ValidTaxRateCard
        key="w-8"
        dataPath="invoice_valid_tax_count"
        titleId="invoicesWithValidTaxRates"
        tooltipAbsoluteId1="invoicesWithValidTaxRates.absoluteNumber1"
        tooltipAbsoluteId2="invoicesWithValidTaxRates.absoluteNumber2"
        containerClass="widget-col-6"
        testIdPrefix="invoices_with_valid_tax_rates"
      />
    ),
    id: 8,
    size: "widget-col-6",
    image: card2
  },
  {
    name: "Invoiced products with valid tax rates",
    component: (
      <ValidTaxRateCard
        key="w-9"
        dataPath="product_valid_tax_count"
        titleId="invoicedProductsWithValidTaxRates"
        tooltipAbsoluteId1="invoicedProductsWithValidTaxRates.absoluteNumber1"
        tooltipAbsoluteId2="invoicedProductsWithValidTaxRates.absoluteNumber2"
        containerClass="widget-col-3"
        testIdPrefix="invoiced_products_with_valid_tax_rates"
      />
    ),
    id: 9,
    size: "widget-col-3",
    image: card4
  },

  {
    name: "Overall VAT Amount this month",
    component: (
      <GenericCard
        key="w-10"
        titleId="overallVatAmountThisMonth"
        dataPath="month.total_vat"
        showCurrency={true}
        tooltipAbsoluteId="overallVatAmountThisMonth.absoluteNumber"
        tooltipPercentId="overallVatAmountThisMonth.percentFigure"
        containerClass="widget-col-6"
        data-testid="vat_amount_current_month"
      />
    ),
    id: 10,
    size: "widget-col-6",
    image: card1
  },
  {
    name: "Overall VAT Amount this year",
    component: (
      <GenericCard
        key="w-11"
        titleId="overallVatAmountThisYear"
        dataPath="year.total_vat"
        showCurrency={true}
        tooltipAbsoluteId="overallVatAmountThisYear.absoluteNumber"
        tooltipPercentId="overallVatAmountThisYear.percentFigure"
        containerClass="widget-col-6"
        data-testid="vat_amount_current_year"
      />
    ),
    id: 11,
    size: "widget-col-6",
    image: card1
  }
  // {
  //     name: 'Average time to credit',
  //     component: <AverageTimeToCredit key="w-14" />,
  //     id: 14,
  //     size: 'widget-col-3',
  //     image: card1
  // },

  // {
  //   name: "Revenu Actual Month Card",
  //   component: <RevenueActualMonth key="w-0" />,
  //   id: 12,
  //   size: "widget-col-3",
  //   image: card1,
  //   tanslation: "VAT Amount this month / Mehrwertsteuerbetrag diesen Monat"
  // },
  // {
  //   name: "Total Revenue this Year Card",
  //   component: <TotalRevenueYear key="w-1" />,
  //   id: 13,
  //   size: "widget-col-3",
  //   image: card2,
  //   tanslation: "VAT Amount this year / Mehrwertsteuerbetrag dieses Jahr"
  // },
];

export const UserProvider = ({ children }) => {
  const navigate = useNavigate();
  const { user } = React.useContext(EcAuthContext);
  const { getData } = React.useContext(APIContext);

  const [currency, setCurrency] = useState({
    code: "EUR",
    symbol: "€"
  });
  const [userData, setUserData] = useState(initUserData);
  const [redirectURI, setRedirectURI] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [noti, setNoti] = useState([]);
  const [smartNotis, setSmartNotis] = useState(notis);
  const [widgetsList, setWidgetsList] = useState(initWidgetsList);
  const [isReorder, setIsReorder] = useState(false);

  const [userWidgetPlaceholder, setUserWidgetPlaceholder] = useState([]);

  const [lang, setLang] = useState(
    localStorage.getItem("lang") === null ? "de" : localStorage.getItem("lang")
  );

  const [isConnectorSaveSuccess, setIsConnectorSaveSuccess] = useState(false);
  const [isUserSaveSuccess, setIsUserSaveSuccess] = useState(false);
  const [isCompanySaveSuccess, setIsCompanySaveSuccess] = useState(false);
  const [isSaveSuccess, setIsSaveSuccess] = useState(false);
  const [isSnackBarVisible, setIsSnackBarVisible] = useState(false);

  const [isAccessKeyErrorVisible, setIsAccessKeyErrorVisible] = useState(false);

  const [hasConnectors, setHasConnectors] = useState(false);

  const [isWhiteLabel, setIsWhiteLabel] = useState(true);

  const [host, setHost] = useState("");

  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  // Follow the language switch in the ec-common-ui header.
  useEffect(() => {
    const handleLangChange = (e) => setLang(e.detail);
    window.addEventListener("ec-lang-changed", handleLangChange);
    return () => window.removeEventListener("ec-lang-changed", handleLangChange);
  }, []);
  const { getRegistrationInfo, isDirectCustomer } =
    React.useContext(EcAuthContext);

  const saveToken = (token, refreshToken) => {
    localStorage.setItem(userToken, token);
    localStorage.setItem(userRefreshToken, refreshToken);
    // window.location.href = '/';
    navigate("/");
  };

  const setLanguage = (lang) => {
    localStorage.setItem("lang", lang);
  };

  const checkUserData = async () => {
    // get Company name Value from subdomain from URL
    // COMPANY Values[spot, jera, dhl, uber, world]
    const host = window.location.host.split(".")[0];
    let companyHost = "";

    if (
      host !== "eclear-solutions" &&
      host !== "dev" &&
      !host.includes("localhost")
    ) {
      if (host.includes("dev-")) {
        companyHost = host.split("dev-")[1];
      } else {
        companyHost = host;
      }
      // setUserData({ ...initUserData, company: host });
    } else if (
      (host === "eclear-solutions" || host === "dev") &&
      !host.includes("localhost")
    ) {
      companyHost = "spot";
      // setUserData({ ...initUserData, company: "spot" });
    } else if (window.location.href.includes("jera")) {
      companyHost = "jera";
      // setUserData({ ...initUserData, company: "spot" });
    } else {
      // localhost
      companyHost = "dhl";
      // setUserData({ ...initUserData, company: "dhl" });
    }
    companyHost === "jera" ? setIsWhiteLabel(true) : setIsWhiteLabel(false);
    // get comapny id and userInfo
    if (user) {
      try {
        const company = await getData(`company`, {
          userId: user.accessToken.payload.sub
        });
        // const userInfo = await getData(`company/${company[0].id}/users`, {
        const userInfo = await getData(URLS_USERS(company[0].id), {
          userId: user.accessToken.payload.sub,
          id: company[0].id
        });
        setUserData({
          ...initUserData,
          companyId: company[0].id,
          company: companyHost,
          userInfo: userInfo[0]
        });
      } catch (err) {
        // console.error(err);
      }
    } else {
      setUserData({ ...initUserData, company: companyHost });
    }
    setHost(companyHost);
  };

  const getConnectors = async () => {
    const res = await getData(URLS.CONNECTOR_CONFIG, {
      userId: user.accessToken?.payload?.sub
    });
    res.length > 0 ? setHasConnectors(true) : setHasConnectors(false);
  };

  useEffect(() => {
    // checkUserData();
    // user?.accessToken?.payload && getConnectors();
    // user?.accessToken?.payload?.email &&
    //   getRegistrationInfo(user?.accessToken?.payload?.email);
  }, [user]);

  // useEffect(() => {
  //   getRegistrationInfo(user?.idToken?.payload?.email);
  // }, [userData]);

  const formatNumber = (number, fixTo = 2) => {
    if (!number) {
      // console.error("formatNumber wrong number value", number);
      return 0;
    }
    const isNegative = number < 0;

    const numberFixed = Math.abs(number.toFixed(fixTo));
    const numberParts = `${numberFixed}`.split(".");
    const numberLeftPart = numberParts[0];
    let numberLeftFormatted = "";

    let counter = 1;
    for (let i = numberLeftPart.length - 1; i > -1; i--) {
      numberLeftFormatted += numberLeftPart[i];
      if (counter > 0 && counter % 3 === 0 && i > 0) {
        numberLeftFormatted += ".";
      }
      counter += 1;
    }
    const finalNumberLeft = numberLeftFormatted.split("").reverse().join("");
    const finalNumber = numberParts[1]
      ? [finalNumberLeft, numberParts[1]].join(",")
      : finalNumberLeft;

    return isNegative ? "-" + finalNumber : finalNumber;
  };

  const logout_user = () => {
    localStorage.removeItem(userRefreshToken);
    localStorage.removeItem(userToken);
    localStorage.removeItem(storeId);
    setUserData(initUserData);
    setUserData({
      ...initUserData,
      company: host
    });
    Navigate("/login");
  };

  // TODO: get user register status
  // const getUserRegisterStatus = async () => {
  //   try {
  //     const status = await fetch()
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  return (
    <UserContext.Provider
      value={{
        userData,
        currency,
        setCurrency,
        isLoggedIn,
        setIsLoggedIn,
        saveToken,
        checkUserData,
        redirectURI,
        setRedirectURI,
        formatNumber,
        noti,
        setNoti,
        logout_user,
        widgetsList,
        setWidgetsList,
        isReorder,
        setIsReorder,
        userWidgetPlaceholder,
        setUserWidgetPlaceholder,
        smartNotis,
        setSmartNotis,
        lang,
        setLang,
        setLanguage,
        // getUserRegisterStatus
        isConnectorSaveSuccess,
        setIsConnectorSaveSuccess,
        isUserSaveSuccess,
        setIsUserSaveSuccess,
        isCompanySaveSuccess,
        setIsCompanySaveSuccess,
        isSnackBarVisible,
        setIsSnackBarVisible,
        isSaveSuccess,
        setIsSaveSuccess,
        hasConnectors,
        setHasConnectors,
        getConnectors,
        isAccessKeyErrorVisible,
        setIsAccessKeyErrorVisible,
        host,
        isWhiteLabel,
        setIsWhiteLabel
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
